import { GetCategoriesIcon, GetSportIcon } from 'assets/icons';
import CloseIcon from 'assets/images/closeIcon.svg?react';
import cn from 'classnames';
import { useEffect } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { useScrollToTab } from 'shared/hooks/useScrollToTab';
import { SportsType } from 'shared/interface';

type TabTypes = 'categories' | 'subCategories';

type PillsTabProps = {
	tabList: any[];
	currentTab: string | number;
	onTabChange: (tab: any) => void;
	categorySwitched?: boolean;
	cyTestRef?: string;
	isLivePage?: string;
	tabType?: TabTypes;
	filteredSubCategory?: any;
	className?: string;
	disableReset?: boolean;
};

const PillsTab = ({
	categorySwitched,
	tabList,
	currentTab,
	onTabChange,
	cyTestRef,
	isLivePage,
	tabType,
	filteredSubCategory,
	className,
	disableReset,
}: PillsTabProps) => {
	const { scrollContainerRef, tabRefs, scrollToTab } = useScrollToTab({ useOffset: true });

	const allSports = { sportName: 'All', sportId: 0 };
	const initialTab = tabList.find((tab) => tab.sportId === currentTab);
	const tabToChange = initialTab || allSports;

	useEffect(() => {
		onTabChange(tabToChange);
	}, [categorySwitched]);

	useEffect(() => {
		scrollToTab(tabList.indexOf(initialTab));
	}, [initialTab]);

	const handleTabClick = (tab: SportsType, index: number) => {
		if (tabType === 'categories' && currentTab === tab.sportId) {
			onTabChange(allSports);
		} else if (currentTab !== tab.sportId) {
			onTabChange(tab);
		} else {
			onTabChange(tab);
		}
	};

	return (
		<ScrollContainer hideScrollbars={false} className="tabs_wrapper" ref={scrollContainerRef}>
			<div className="tabs_pill" data-cy={cyTestRef}>
				{tabList.map((tab, index) => (
					<div
						ref={(el) => (tabRefs.current[index] = el)}
						className={cn(`${className}`, {
							active: !isLivePage && currentTab === tab.sportId,
							liveActivePills: isLivePage && currentTab === tab.sportId,
							resetDisabled: disableReset,
						})}
						onClick={() => handleTabClick(tab, index)}
						key={`marketTypes-pill-${index}-${tab.sportName}`}
					>
						{tabType === 'categories' && (
							<div className="flex">
								<GetSportIcon id={tab.sportId} />
							</div>
						)}
						{tabType === 'subCategories' && (
							<div className="flex">
								{filteredSubCategory
									.filter((category: any) => category.categoryId === tab.sportId)
									.map((category: any) => (
										<GetCategoriesIcon key={category.categoryId} category={category} className="categoriesIcon" />
									))}
							</div>
						)}

						<div>{tab.sportName}</div>
						{!isLivePage && !disableReset
							? currentTab === tab.sportId && <CloseIcon className="size-2.5" onClick={() => onTabChange(tab)} />
							: ''}
					</div>
				))}
			</div>
		</ScrollContainer>
	);
};

export default PillsTab;
